import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { moduleslist, serviceConstants } from 'src/app/constants/service.constants';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Screen, SCREEN_CONTROL, Module, dropdownsource, Control_Dependents_Details, Control_Dependents } from 'src/app/models/common';
import { ConfigureControlsAddComponent } from '../configure-controls-modal/configure-controls-add/configure-controls-add.component';
import { GridApi } from 'ag-grid-community';
import { EditOthersRenderer } from 'src/app/common/client-grid/edit-others-operations.component';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { ConfigureControlsModalComponent } from '../configure-controls-modal/configure-controls-modal.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import * as _ from 'lodash';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-screen-repository-modal',
  templateUrl: './screen-repository-modal.component.html',
  styleUrls: ['./screen-repository-modal.component.scss']
})
export class ScreenRepositoryModalComponent implements OnInit {
  @Input() public Content: any;
  RequiredSettings: boolean = true;
  RequiredSendBackRowData: boolean = true;
  userForm: UntypedFormGroup;
  formFields;
  stateOptionsSample = moduleslist;
  modulelist: Module[] = [];
  modulessource: dropdownsource[] = [];
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  public selectData: any[] = [];
  screen: Screen;
  columnDefs;
  gridApi: GridApi;
  selectedRow;
  selectedRecord: SCREEN_CONTROL;
  rowData: SCREEN_CONTROL[] = [];
  StaticrowData: SCREEN_CONTROL[] = [];
  DynamicrowData: SCREEN_CONTROL[] = [];
  gridOptions;
  context: any;
  cancelBtn: string = "Cancel";
  screenType: any;
  //screenRepositoryForm = new FormGroup({});
  screenRepositoryForm = new UntypedFormGroup({
    ID: new UntypedFormControl(null),
    CODE: new UntypedFormControl(""),
    NAME: new UntypedFormControl(""),
    DESCRIPTION: new UntypedFormControl(null),
    SCREEN_TYPE: new UntypedFormControl(null),
    MODULE_ID: new UntypedFormControl(),
    Status: new UntypedFormControl(true),
  });
  frameworkComponents: any;
  loadTeam: boolean = false;
  TempOperations: any = [];
  operations: any;
  StaticTempOperations: any = [];

  constructor(
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    public commonService: CommonService
  ) {
    this.columnDefs = [
      {
        "headerName": "Name",
        "field": "LABEL",
        tooltipField: "LABEL"
      }, {
        "headerName": "Type",
        "field": "CONTROLTYPE",
        tooltipField: "CONTROLTYPE"
      },
      {
        "headerName": "Status",
        "field": "STATEVALUE",
        tooltipField: "STATEVALUE"
      },
      {
        "headerName": "Mandatory",
        "field": "IS_MANDATORYStr",
        tooltipField: "IS_MANDATORYStr"
      },
      {
        headerName: "Actions",
        field: "value",
        cellRenderer: "editOthersRenderer",
        colId: "params",
        sortable: false,
        cellStyle: { "overflow": 'visible' }
      }
    ]

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }

    this.context = { componentParent: this };
    this.frameworkComponents = {
      editOthersRenderer: EditOthersRenderer
    };
  }

  ngOnInit() {
    this.userForm = new UntypedFormGroup({
      CODE: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      MODULE_ID: new UntypedFormControl("")
    });
    this.screenRepositoryForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      CODE: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      DESCRIPTION: new UntypedFormControl(null),
      SCREEN_TYPE: new UntypedFormControl(null),
      MODULE_ID: new UntypedFormControl(this.Content.content.ModuleID),
      Status: new UntypedFormControl(true),
    });
    this.getScreenData();

    if (this.Content.heading !== "View") {
      this.TempOperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        }
      ];
      // this.operations = this.TempOperations.map(operation => {
      //   return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
      // });

      this.StaticTempOperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Hide",
          "id": "hide"
        },
        {
          "name": "Display",
          "id": "Display"
        }
      ];
      // this.operations = this.TempOperations.map(operation => {
      //   return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
      // });
    }
  }

  getScreenData() {
    if (this.Content.content && this.Content.content.id && this.Content.heading === 'Edit') { // Edit mode  this.Content.content && this.Content.content.id &&
      //this.Content.content.id = 1;
      this.summaryService.getScreenRepositorySummary(this.Content.content.id, this.Content.content.ModuleName).subscribe((result) => {
        this.screen = result;
        this.setForm(this.screen);
        this.rowData = result[0].SCREEN_CONTROL;
        this.StaticrowData = this.getGridData(result[0].SCREEN_CONTROL, 'static');
        this.DynamicrowData = this.getGridData(result[0].SCREEN_CONTROL, 'dynamic');
        ;
        this.loadTeam = false;
        setTimeout(() => {
          this.loadTeam = true;
          document.body.click();
        }, 300);
        this.screenType = this.screen.SCREEN_TYPE;
      })
    } else if (this.Content.content && this.Content.content.id && this.Content.heading === 'View') { //View mode
      ;
      this.cancelBtn = "Close";
      this.summaryService.getScreenRepositorySummary(this.Content.content.id, this.Content.content.ModuleName).subscribe((result) => {
        this.screen = result;
        this.setForm(this.screen);
        this.rowData = result[0].SCREEN_CONTROL;
        this.StaticrowData = this.getGridData(result[0].SCREEN_CONTROL, 'static');
        this.DynamicrowData = this.getGridData(result[0].SCREEN_CONTROL, 'dynamic');
        this.loadTeam = false;
        setTimeout(() => {
          this.loadTeam = true;
          document.body.click();
          this.screenRepositoryForm.disable({ emitEvent: false });
        }, 300);
        this.screenType = this.screen.SCREEN_TYPE;
      })
    }
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    ;
    if (opr != null) {
      opr.callback();
    }
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {

  }


  private setForm(screen: Screen): void {
    this.screen = screen[0];
    this.screenRepositoryForm = new UntypedFormGroup({
      Status: new UntypedFormControl(this.screen.Status),
      ID: new UntypedFormControl(this.screen.ID),
      CODE: new UntypedFormControl(this.screen.CODE),
      NAME: new UntypedFormControl(this.screen.NAME),
      DESCRIPTION: new UntypedFormControl(this.screen.DESCRIPTION),
      MODULE_ID: new UntypedFormControl(this.screen.MODULE_ID),
      SCREEN_TYPE: new UntypedFormControl(this.screen.SCREEN_TYPE)
    });

    // this.screenRepositoryForm.controls["NAME"].enable();
    // this.screenRepositoryForm.controls["Status"].enable();
    this.screenRepositoryForm.controls["DESCRIPTION"].enable();

    if (this.screenRepositoryForm.controls["SCREEN_TYPE"].value == 1) {
      this.screenRepositoryForm.controls["NAME"].disable();
      this.screenRepositoryForm.controls["Status"].disable();
      //this.screenRepositoryForm.controls["DESCRIPTION"].disable();
    }
    else {
      this.screenRepositoryForm.controls["NAME"].enable();
      this.screenRepositoryForm.controls["Status"].enable();
      //this.screenRepositoryForm.controls["DESCRIPTION"].enable();
    }
  }


  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.screenRepositoryForm.getRawValue();
    if (formData.NAME === null || formData.NAME === "" || formData.NAME === undefined) {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Screen Name<br/>";
      isValid = false;
    } else if (formData.NAME != null && formData.NAME != undefined && formData.NAME.trim() == "") {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Screen Name<br/>";
      isValid = false;
    }
    else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }
    if (this.screenRepositoryForm.controls["SCREEN_TYPE"].value != 1) {
      if (this.rowData != undefined && this.rowData.length == 0) {
        message += "Please select at least one field and save the screen<br/>";
        isValid = false;
      }
    }
    if (!isValid)
      this.commonService.ValidationBanner(message);
    //this.modalService.open(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
    return isValid;
  }
  save() {
    if (this.validateControls()) {
      let formData = this.screenRepositoryForm.getRawValue();
      formData.NAME = formData.NAME == null ? null : formData.NAME == undefined ? undefined : formData.NAME.trim();
      let rowdata = [];
      this.StaticrowData.forEach((item) => {
        item["Operations"] = null;
        rowdata.push(item);
      });
      this.DynamicrowData.forEach((item) => {
        item["Operations"] = null;
        rowdata.push(item);
      });

      let IsDisplayExits = this.StaticrowData.filter((item) => {
        return (item.IS_DISPLAY != 0)
      })[0];
      let IsActiveExits = this.DynamicrowData.filter((item: any) => {
        return (item.RECORD_STATE == 1)
      })[0];

      if ((IsDisplayExits != null && IsDisplayExits != undefined) || (IsActiveExits != null && IsActiveExits != undefined)) {

        formData["SCREEN_CONTROL"] = rowdata;
        formData["MODULE_ID"] = this.Content.content.ModuleID;
        if (this.Content.heading === 'Add') {
          this.summaryService.screenInsert(serviceConstants.apiURL + 'api/screen/insert', formData).subscribe(result => {
            if (result.Status === 0) {
              //   this.action.next(true);
              this.commonService.SuccessBanner("Screen '" + formData["NAME"] + "' added successfully");

              this.modalRef.close(true);
            }
            else {
              this.commonService.ValidationBanner(result.Message);
              //this.modalService.open(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
            }
          })

        } else if (this.Content.content && this.Content.content.id && this.Content.heading === 'Edit') {
          this.summaryService.screenUpdate(serviceConstants.apiURL + 'api/screen/update', formData).subscribe(result => {
            if (result.Status === 0) {
              this.commonService.SuccessBanner("Screen '" + formData["NAME"] + "' updated successfully");
              //    this.action.next();
              this.modalRef.close();
            }
            else {
              this.commonService.ValidationBanner(result.Message);
              //this.modalService.open(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
            }
          })
        }
      }
      else {
        this.commonService.ValidationBanner("At-least one static/flex field should be available in active/display state to save the details");
      }
    }

  }

  edit(data) {
    let FlexyData = this['self'].DynamicrowData.filter((item) => {
      return item.SERIAL_NO > data.SERIAL_NO && data.IsActive == true;
    });
    let row = data;
    let screenId = this['self'].screenRepositoryForm.controls["ID"].value;
    const modalRefAdd = this['self'].modalService.open(ConfigureControlsAddComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true,

    });
    let str = '';
    this['self'].DynamicrowData.forEach((item) => {
      if (data.ID != item.ID) {
        item.Control_Condtions.forEach((cond) => {
          cond.ConditionsList.forEach((flds) => {
            if (flds.Mapped_Controls_List && flds.Mapped_Controls_List.length > 0) {
              str = str + flds.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
          })
        });
      }
    });
    let flexFieldsFiltered: SCREEN_CONTROL[] = [];
    flexFieldsFiltered = FlexyData.filter(item => str.indexOf(item.ID) == -1 && item.IS_STATIC == false && item.IsActive == true);

    modalRefAdd.componentInstance.Content = {
      heading: 'Edit',
      content: { id: screenId, operation: "Edit", Data: row },
      rowData: _.cloneDeep(this['self'].rowData),
      FlexyFields: flexFieldsFiltered
    }
    modalRefAdd.result.then(result => {
      this['self'].rowData.forEach((item) => {
        if (item.ID == result.ID) {
          item.STATE = result.STATE;
          item.STATEVALUE = result.STATEVALUE;
          item.CONTROL = result.CONTROL;
          item.ID = result.ID;
          item.IS_MANDATORY = result.IS_MANDATORY;
          item.RECORD_STATE = item.STATEVALUE == "Active" ? 1 : 0;
          item.IS_MANDATORYStr = result.IS_MANDATORYStr;
          item.CONTROLTYPE = result.CONTROLTYPE;
          item.SERIAL_NO = result.SERIAL_NO;
          item.SCREEN_ID = result.SCREEN_ID;
          item.IsAllowMultipleFiles = result.ISALLOWMULTIPLEFILES;
          item.ISALLOWMULTIPLEFILES = result.ISALLOWMULTIPLEFILES;
          item.GROUP_VALUES = result.GROUP_VALUES;
          item.GROUP_VALUES_LIST = result.GROUP_VALUES_LIST;
          item.SUBFIELDNAME = result.SUBFIELDNAME;
          item.LABEL = result.LABEL;
          item.DATEFORMATE = result.DATEFORMATE;
          item.IsActive = result.IsActive;
          item.MAXCHARACTERLENGTH = result.MAXCHARACTERLENGTH;
          item.PURPOSE = result.PURPOSE;
          item.Control_Condtions = result.Control_Condtions;
        }
      });
      ;
      this['self'].StaticrowData = this['self'].getGridData(this['self'].rowData, 'static');
      this['self'].DynamicrowData = this['self'].getGridData(this['self'].rowData, 'dynamic');
      this['self'].loadTeam = false;
      setTimeout(() => {
        this['self'].loadTeam = true;
        document.body.click();
      }, 100);
    })
  }
  delete(data) {
    let row = data;
    const modalRef = this["self"].modalService.open(DeleteBoxComponent, {
      backdrop: false
    })
    modalRef.componentInstance.Content = {
      heading: 'Delete',
      custommessage: 'Are you sure you want to delete the Field ' + "'" + row.LABEL + "'" + ' ?',
      ProceedButtonName: "Delete",
      TerminateButtonName: "Cancel"
    }
    modalRef.result.then(result => {
      if (result == "okclick") {
        if (row.ROWSTATE != "Add") {
          let res: boolean = this['self'].checkFieldUsedInCondition(data);
          if (res) {
            this['self'].commonService.ValidationBanner("You cannot delete this field as it is associated to other configuration");
          }
          else {
            this['self'].summaryService.checkControlReference(row.ID).subscribe((result) => {
              if (result) {
                this['self'].commonService.ValidationBanner("You cannot delete this field as it is associated to an application");
              }
              else {
                let eleindex = 0;
                this['self'].rowData.forEach((item, index) => {
                  if (item.ID == row.ID) {
                    this['self'].loadTeam = false;
                    eleindex = index;
                    this['self'].rowData.splice(index, 1);
                    setTimeout(() => {
                      this['self'].loadTeam = true;
                      document.body.click();
                    }, 100);
                  }
                });

                this['self'].StaticrowData = this['self'].getGridData(this['self'].rowData, 'static');
                this['self'].DynamicrowData = this['self'].getGridData(this['self'].rowData, 'dynamic');
                this['self'].loadTeam = false;
                setTimeout(() => {
                  this['self'].loadTeam = true;
                  document.body.click();
                }, 100);
              }
            });
          }
        }
        else {
          let res: boolean = this['self'].checkFieldUsedInCondition(data);
          if (res) {
            this['self'].commonService.ValidationBanner("You cannot delete this field as it is associated to other configuration");
          }
          else {
            let eleindex = 0;
            this['self'].rowData.forEach((item, index) => {
              if (item.ID == row.ID) {
                eleindex = index;
                this['self'].rowData.splice(index, 1);

              }
            });
            this['self'].StaticrowData = this['self'].getGridData(this['self'].rowData, 'static');
            this['self'].DynamicrowData = this['self'].getGridData(this['self'].rowData, 'dynamic');
            this['self'].loadTeam = false;
            setTimeout(() => {
              this['self'].loadTeam = true;
              document.body.click();
            }, 100);
          }
        }
      }
    });
  }

  checkFieldUsedInCondition(data) {
    let canDelete: boolean = false;
    this.DynamicrowData.forEach((item) => {
      item.Control_Condtions.forEach((cond) => {
        cond.ConditionsList.forEach((flds) => {
          if (flds.Mapped_Controls_List && flds.Mapped_Controls_List.length > 0) {
            let controlId = flds.Mapped_Controls_List.filter((x) => { return x.ControlID == data.ID });
            if (controlId && controlId.length > 0) {
              canDelete = true;
              return canDelete;
            }
          }
        })
      });
    });
    return canDelete;
  }

  addRow() {
    if (this.DynamicrowData == undefined && this.DynamicrowData == null) {
      this.DynamicrowData = [];
    }
    let modalRefAdd = this.modalService.open(ConfigureControlsAddComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });

    //24R1 Change Start
    //#region 24R1 Change Start
    let filteredFields = [];
    let str = [];
    this.DynamicrowData.forEach((item) => {
      item.Control_Condtions.forEach((cond) => {
        cond.ConditionsList.forEach((flds) => {
          if (flds.Mapped_Controls_List && flds.Mapped_Controls_List.length > 0) {
            flds.Mapped_Controls_List.forEach((ci) => {
              if (ci && ci.ControlID && !str.includes(ci.ControlID)) {
                str.push(ci.ControlID);
              }
            })
          }
        })
      });
    });
    let filteredfldString = str.length > 0 ? str.join(",") : "";
    let flexFieldsFiltered: SCREEN_CONTROL[] = [];
    flexFieldsFiltered = this.rowData.filter(item => filteredfldString.indexOf(item.ID) == -1 && item.IS_STATIC == false && item.IsActive == true);
    //#endregion 24R1 Change End
    //24R1 Change End
    modalRefAdd.componentInstance.Content = {
      heading: 'Add',
      content: { id: "", operation: "Add" },
      rowData: this.rowData,
      //FlexyFields: this.DynamicrowData
      FlexyFields: flexFieldsFiltered
    }
    modalRefAdd.result.then(result => {
      this.loadTeam = false;
      let TempList = [];
      result.RECORD_STATE = result.STATEVALUE == "Active" ? 1 : 0;
      if (this.rowData == undefined && this.rowData == null) {
        this.rowData = [];
      }
      if (this.DynamicrowData == undefined && this.DynamicrowData == null) {
        this.DynamicrowData = [];
      }
      TempList.push(result);
      this.rowData = TempList.concat(this.rowData);
      let finalList = TempList.concat(this.DynamicrowData);
      this.DynamicrowData = this.getGridData(finalList, 'dynamic');
      setTimeout(() => {
        this.loadTeam = true;
        document.body.click();
      }, 100);
      //this.SaveControls();
      //this.getScreencontrolsslist();
    })
  }

  hide(data) {
    this['self'].rowData.forEach((item) => {
      if (item.ID == data.ID) {
        item.IS_DISPLAY = 0;
        item.STATEVALUE = item.IS_DISPLAY == 0 ? "Hidden" : "Display";
      }
    });

    this['self'].StaticrowData = this['self'].getGridData(this['self'].rowData, 'static');
    this['self'].DynamicrowData = this['self'].getGridData(this['self'].rowData, 'dynamic');

    this['self'].loadTeam = false;
    setTimeout(() => {
      this['self'].loadTeam = true;
      document.body.click();
    }, 100);
  }
  Display(data) {

    this['self'].rowData.forEach((item) => {
      if (item.ID == data.ID) {
        item.IS_DISPLAY = 1;
        item.STATEVALUE = item.IS_DISPLAY == 0 ? "Hidden" : "Display";
      }
    });
    this['self'].StaticrowData = this['self'].getGridData(this['self'].rowData, 'static');
    this['self'].DynamicrowData = this['self'].getGridData(this['self'].rowData, 'dynamic');

    this['self'].loadTeam = false;
    setTimeout(() => {
      this['self'].loadTeam = true;
      document.body.click();
    }, 100);
  }
  SaveControls(): void {

  }

  addcontrol(): any {
    this.modalRef.dismiss();
  }

  getGridData(Data: any, type: any): any {
    let FilterData = [];
    if (type == "static") {
      this.StaticTempOperations = [];
      Data.forEach((item) => {
        this.StaticTempOperations = [];
        if (item.IS_STATIC) {
          if (item.IS_EDITABLE || item.IS_NAME_EDITABLE == true) {
            this.StaticTempOperations.push({
              "name": "Edit",
              "id": "edit"
            });
          }
          if (item.IS_DISPLAY != 2) {
            this.StaticTempOperations.push({
              "name": "Hide",
              "id": "hide"
            });
            this.StaticTempOperations.push({
              "name": "Display",
              "id": "Display"
            });
          }
          item.CONTROLTYPE = this.getcontroltype(item.CONTROL);
          item.IS_MANDATORYStr = item.IS_MANDATORY == true ? "Yes" : "No";
          item.STATEVALUE = item.IS_DISPLAY == 0 ? "Hidden" : "Display";
          item["Operations"] = this.StaticTempOperations.map(operation => {
            return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
          });
          FilterData.push(item);
        }
        if (this.Content.heading == "View") {
          item["Operations"] = [];
        }
      });
      FilterData.forEach((item) => {
        if (item.PARENT_FIELD_CODE != null && item.PARENT_FIELD_CODE != undefined && item.PARENT_FIELD_CODE != "") {
          let ParentRecord = FilterData.filter((citem) => {
            return citem.FIELD_CODE == item.PARENT_FIELD_CODE
          })[0];
          if (ParentRecord != null && ParentRecord != undefined && ParentRecord.IS_DISPLAY == 0) {
            item["Operations"] = [];
          }
        }
      });

      return FilterData;
    }
    else if (type == "dynamic") {
      Data.forEach((item, index) => {
        if (item.IS_STATIC != true) {
          item.SERIAL_NO = (index + 1);
          item.CONTROLTYPE = this.getcontroltype(item.CONTROL);
          item.IS_MANDATORYStr = item.IS_MANDATORY == true ? "Yes" : "No";
          item.STATEVALUE = item.RECORD_STATE == 1 ? "Active" : "Inactive";
          item["Operations"] = this.TempOperations.map(operation => {
            return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
          });
          FilterData.push(item);
        }
        if (this.Content.heading == "View") {
          item["Operations"] = [];
        }
      });
      return FilterData;
    }

  }

  getcontroltype(ctype: any): string {
    ctype = parseInt(ctype);
    var controltype = "";
    switch (ctype) {
      case 1:
        controltype = "Alpha numeric Text";
        break;
      case 2:
        controltype = "Alphabet Text";
        break;
      case 3:
        controltype = "Number";
        break;
      case 4:
        controltype = "Single select dropdown";
        break;
      case 5:
        controltype = "Date";
        break;
      case 6:
        controltype = "Checkbox";
        break;
      case 7:
        controltype = "Radio Buttons";
        break;
      case 8:
        controltype = "Upload";
        break;
      case 9:
        controltype = "Label";
        break;
      case 10:
        controltype = "Multi-select dropdown";
        break;
      case 11:
        controltype = "Text area";
        break;
      default:

        break;
    }


    return controltype;
  }
  onOperationClick(operation) {
    if (operation != null && operation != undefined && operation != "") {
      operation.callback();
    }
  }
  Reorder() {
    let hasCondition: boolean = false;
    if (this.DynamicrowData && this.DynamicrowData.length > 0) {
      let allControlConditions = this.DynamicrowData.map(screenControl => screenControl.Control_Condtions);
      if (allControlConditions != null && allControlConditions.length > 0) {
        allControlConditions.forEach((item) => {
          if (item.length > 0) {
            hasCondition = true;
            return;
          }
        })
      }
    }
    if (hasCondition) {
      this.commonService.ValidationBanner("The fields cannot be reordered as it has conditions configured");
    }
    else {
      let screenId = this.screenRepositoryForm.controls["ID"].value;
      let modalRefAdd = this.modalService.open(ConfigureControlsModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg right modal-right',
        animation: true
      });
      modalRefAdd.componentInstance.Content = {
        heading: 'Reorder',
        content: { id: screenId, operation: "Edit", Data: this.DynamicrowData },
      }
      modalRefAdd.result.then(result => {
        // this.commonService.SuccessBanner("Order of Fields saved successfully");
        this.DynamicrowData = result
        this.loadTeam = false;
        setTimeout(() => {
          this.loadTeam = true;
          document.body.click();
        }, 100);
      })
    }



  }



}
